import React from 'react';
import { Fab } from '@mui/material';
import { ArcFabProps } from './types';

const ArcFab: React.FC<ArcFabProps> = (props) => {
  return <Fab sx={{ boxShadow: 'none' }} {...props} />;
};

export default ArcFab;